import { Typography } from '@mui/material'
import { useTranslation } from 'next-i18next'
import { match } from 'ts-pattern'
import ArrowLeft from 'assets/icons/nucleo/18px_arrow-left.svg'
import Xmark from 'assets/icons/nucleo/18px_xmark.svg'
import { Drawer } from 'components/common/Drawer/Drawer'
import { unifiedColors } from 'styles/colors'
import { DateTabContent } from './DateTabContent'
import { LocationTabContent } from './LocationTabContent'
import {
  MobileContentHeader,
  MobileContent as StyledMobileContent
} from './SearchBar.style'
import { SearchBarHeader, SearchTab } from './SearchBarHeader'
import { TypeTabContent } from './TypeTabContent'

interface MobileContentProps {
  forcedExpanded?: boolean
  open: boolean
  searchTab: SearchTab
  setSearchTab: (tab: SearchTab) => void
  handleClickAway: () => void
  handlePrevious: () => void
  handleOpen: (tabType: SearchTab) => void
}

export const MobileContent = ({
  forcedExpanded,
  open,
  searchTab,
  handleClickAway,
  handlePrevious,
  handleOpen,
  setSearchTab
}: MobileContentProps) => {
  const { t } = useTranslation(['common', 'home'])
  return (
    <StyledMobileContent $open={open}>
      <Drawer
        open={open}
        aria-label="mobile filters"
        onClose={handleClickAway}
        anchor="bottom"
        transitionDuration={300}
        sx={{
          '& .MuiDrawer-paper': {
            height: '100%',
            backgroundColor: unifiedColors.surface.subdued
          }
        }}
      >
        <MobileContentHeader>
          <ArrowLeft onClick={handlePrevious} />
          <Typography variant="h5">
            {match(searchTab)
              .with('type', () => t('header.searchPlaceholder'))
              .with('date', () => t('home:head.findRaceDate'))
              .with('location', () => t('home:head.findRaceLocation'))
              .with(null, () => null)
              .exhaustive()}
          </Typography>
          <Xmark onClick={handleClickAway} />
        </MobileContentHeader>
        {match(searchTab)
          .with('type', () => (
            <TypeTabContent close={handleClickAway} setSearchTab={setSearchTab}>
              <SearchBarHeader
                forcedExpanded={forcedExpanded}
                handleOpen={handleOpen}
                hideSearchButton
                close={handleClickAway}
                searchTab={searchTab}
              />
            </TypeTabContent>
          ))
          .with('date', () => <DateTabContent setSearchTab={setSearchTab} />)
          .with('location', () => <LocationTabContent />)
          .with(null, () => null)
          .exhaustive()}
      </Drawer>
    </StyledMobileContent>
  )
}
